import React from "react";

const TextAreaField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  rows = 3,
  required = false,
  readOnly = false,
}) => {
  return (
    <div className="space-y-2">
      {label && (
        <label
          htmlFor={name}
          className="text-sm font-medium text-foreground block"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        required={required}
        readOnly={readOnly}
        className={`flex min-h-[60px] w-full rounded-sm border px-3 py-2 text-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ${
          readOnly
            ? "border-gray-200 bg-gray-50 text-muted-foreground cursor-not-allowed resize-none"
            : "border-gray-200 bg-background hover:border-gray-300 focus:border-primary"
        }`}
      />
    </div>
  );
};

export default TextAreaField;
